export const USER_ACCOUNT_SETTING_TABS = {
    MANAGE_LICENSE_TAB: { key: 'MANAGE_LICENSE_TAB', value: 'Manage License' },
    MANAGE_TEAMS_TAB: { key: 'MANAGE_TEAMS_TAB', value: 'Manage Teams' },
    MANAGE_USERS_TAB: { key: 'MANAGE_USERS_TAB', value: 'Manage Users' },
    MANAGE_STORAGE_TAB: { key: 'MANAGE_STORAGE_TAB', value: 'Manage Storage' },
    MANAGE_LANGUAGE_TAB: { key: 'MANAGE_LANGUAGE_TAB', value: 'Manage Language' },
    MANAGE_SSO: { key: 'MANAGE_SSO', value: 'Manage single sign on' },
    MANAGE_SMTP_SERVER_TAB: { key: 'MANAGE_SMTP_SERVER_TAB', value: 'Manage SMTP server' },
    MANAGE_FAX_CONFIGURATION_TAB: { key: 'MANAGE_FAX_CONFIGURATION_TAB', value: 'Manage Fax Configuration' },
    MANAGE_FAX_ACCOUNT_TAB: { key: 'MANAGE_FAX_ACCOUNT_TAB', value: 'Manage Fax Account' },
    MANAGE_PRINTER_CONFIGURATION_TAB: { key: 'MANAGE_PRINTER_CONFIGURATION_TAB', value: 'Manage Printer Configuration' },
    MANAGE_SHORT_MESSAGE_CONFIGURATION_TAB: {
        key: 'MANAGE_SHORT_MESSAGE_CONFIGURATION_TAB',
        value: 'Manage Short Message Config',
      },
      MANAGE_TEXT_TO_SPEECH_CONFIGURATION_TAB: {
        key: 'MANAGE_TEXT_TO_SPEECH_CONFIGURATION_TAB',
        value: 'Manage TTS Configuration',
      },
    ALERTS_AND_NOTIFICATIONS_TAB: { key: 'ALERTS_AND_NOTIFICATIONS_TAB', value: 'Alerts & Notifications' },
    EXTERNAL_SERVICES_TAB: { key: 'EXTERNAL_SERVICES_TAB', value: 'External Email/SMS config' },
    HYBRID_MAIL_CONFIG_TAB: { key: 'HYBRID_MAIL_CONFIG_TAB', value: 'Hybrid Mail Configuration' },
    MANAGE_PRINT_DEFAULTS_TAB: { key: 'MANAGE_PRINT_DEFAULTS_TAB', value: 'Print Defaults' },
    MANAGE_PRINT_OPTION_CATALOG_TAB: {
        key: 'MANAGE_PRINT_OPTION_CATALOG_TAB',
        value: 'Print Option Values',
    },
}

export const MANAGE_FAX_CONFIGURATION = {
    UNABLE_TO_FETCH_FAX_DETAILS_ERROR_MESSAGE: { key: 'UNABLE_TO_FETCH_FAX_DETAILS_ERROR_MESSAGE', value: 'An error occurred during the retrieval of fax configuration details' },
    EDIT_FAX_CONFIGURATION_TOOLTIP: { key: 'EDIT_FAX_CONFIGURATION_TOOLTIP', value: 'Edit Fax Configuration' },
    DELETE_FAX_CONFIGURATION_TOOLTIP: { key: 'DELETE_FAX_CONFIGURATION_TOOLTIP', value: 'Delete Fax Configuration' },
    ADD_FAX_CONFIGURATION_BUTTON: { key: 'ADD_FAX_CONFIGURATION_BUTTON', value: 'Add Fax Configuration' },
    MANAGE_FAX_CONFIGURATION_TITLE: { key: 'MANAGE_FAX_CONFIGURATION_TITLE', value: 'Manage Fax Configuration' },
    MANAGE_FAX_CONFIGURATION_DESCRIPTION: { key: 'MANAGE_FAX_CONFIGURATION_DESCRIPTION', value: 'Manage Fax Configuration here' },
}

export const MANAGE_PRINT_DEFAULTS = {
    TITLE: { key: 'MANAGE_PRINT_DEFAULTS_TITLE', value: 'Organization Print Defaults' },
    DESCRIPTION: {
        key: 'MANAGE_PRINT_DEFAULTS_DESCRIPTION',
        value:
            'These settings apply organization-wide and may be overridden at the template level where supported.',
    },
    COLOR_MODE_LABEL: { key: 'MANAGE_PRINT_DEFAULTS_COLOR_MODE_LABEL', value: 'Color Mode' },
    COLOR_MODE_HELP: {
        key: 'MANAGE_PRINT_DEFAULTS_COLOR_MODE_HELP',
        value: 'Controls whether pages are printed in color or Black & White.',
    },
    PAPER_WEIGHT_LABEL: { key: 'MANAGE_PRINT_DEFAULTS_PAPER_WEIGHT_LABEL', value: 'Paper Weight' },
    PAPER_WEIGHT_HELP: {
        key: 'MANAGE_PRINT_DEFAULTS_PAPER_WEIGHT_HELP',
        value: 'Gram weight of the paper used.',
    },
    MAIL_TYPE_LABEL: { key: 'MANAGE_PRINT_DEFAULTS_MAIL_TYPE_LABEL', value: 'Mail Type' },
    MAIL_TYPE_HELP: {
        key: 'MANAGE_PRINT_DEFAULTS_MAIL_TYPE_HELP',
        value: 'Postal service priority class for outgoing mail.',
    },
    ENVELOPE_TYPE_LABEL: { key: 'MANAGE_PRINT_DEFAULTS_ENVELOPE_TYPE_LABEL', value: 'Envelope Type' },
    ENVELOPE_TYPE_HELP: {
        key: 'MANAGE_PRINT_DEFAULTS_ENVELOPE_TYPE_HELP',
        value: 'Envelope type for outgoing mail.',
    },
    RETURN_ENVELOPE_LABEL: { key: 'MANAGE_PRINT_DEFAULTS_RETURN_ENVELOPE_LABEL', value: 'Return Envelope' },
    RETURN_ENVELOPE_HELP: {
        key: 'MANAGE_PRINT_DEFAULTS_RETURN_ENVELOPE_HELP',
        value: 'Include a pre-addressed return envelope with the mailing.',
    },
    RETURN_ENVELOPE_YES: { key: 'MANAGE_PRINT_DEFAULTS_RETURN_ENVELOPE_YES', value: 'Yes' },
    RETURN_ENVELOPE_NO: { key: 'MANAGE_PRINT_DEFAULTS_RETURN_ENVELOPE_NO', value: 'No' },
    SAVE_BUTTON: { key: 'MANAGE_PRINT_DEFAULTS_SAVE_BUTTON', value: 'Save Settings' },
    RESET_BUTTON: { key: 'MANAGE_PRINT_DEFAULTS_RESET_BUTTON', value: 'Reset to Defaults' },
    SAVE_SUCCESS_MESSAGE: {
        key: 'MANAGE_PRINT_DEFAULTS_SAVE_SUCCESS_MESSAGE',
        value: 'Print defaults saved successfully.',
    },
    SAVE_ERROR_MESSAGE: {
        key: 'MANAGE_PRINT_DEFAULTS_SAVE_ERROR_MESSAGE',
        value: 'Unable to save print defaults. Please try again.',
    },
    FETCH_ERROR_MESSAGE: {
        key: 'MANAGE_PRINT_DEFAULTS_FETCH_ERROR_MESSAGE',
        value: 'Unable to load print defaults. Please try again.',
    },
    RESET_SUCCESS_MESSAGE: {
        key: 'MANAGE_PRINT_DEFAULTS_RESET_SUCCESS_MESSAGE',
        value: 'Print defaults reset to organization defaults.',
    },
    CATALOG_EMPTY_SELECT_PLACEHOLDER: {
        key: 'MANAGE_PRINT_DEFAULTS_CATALOG_EMPTY_SELECT_PLACEHOLDER',
        value: 'No catalog values configured',
    },
}

export const MANAGE_PRINT_OPTION_CATALOG = {
    TITLE: { key: 'MANAGE_PRINT_OPTION_CATALOG_TITLE', value: 'Print Option Values' },
    DESCRIPTION: {
        key: 'MANAGE_PRINT_OPTION_CATALOG_DESCRIPTION',
        value:
            'Define allowed values for Color Mode, Mail Type, and Envelope Type. These lists populate dropdowns in Print Defaults and Template Print Settings. Reorder values to change their display order.',
    },
    ORG_CONTEXT_REQUIRED: {
        key: 'MANAGE_PRINT_OPTION_CATALOG_ORG_CONTEXT_REQUIRED',
        value: 'An organization must be selected to manage print catalog values.',
    },
    COLOR_MODE_TITLE: { key: 'MANAGE_PRINT_OPTION_CATALOG_COLOR_MODE_TITLE', value: 'Color Mode' },
    COLOR_MODE_DESC: {
        key: 'MANAGE_PRINT_OPTION_CATALOG_COLOR_MODE_DESC',
        value: 'Allowed values for the Color Mode field on Print Defaults and Template Print Settings.',
    },
    MAIL_TYPE_TITLE: { key: 'MANAGE_PRINT_OPTION_CATALOG_MAIL_TYPE_TITLE', value: 'Mail Type' },
    MAIL_TYPE_DESC: {
        key: 'MANAGE_PRINT_OPTION_CATALOG_MAIL_TYPE_DESC',
        value: 'Allowed postal service priority classes shown in the Mail Type dropdown.',
    },
    ENVELOPE_TYPE_TITLE: { key: 'MANAGE_PRINT_OPTION_CATALOG_ENVELOPE_TYPE_TITLE', value: 'Envelope Type' },
    ENVELOPE_TYPE_DESC: {
        key: 'MANAGE_PRINT_OPTION_CATALOG_ENVELOPE_TYPE_DESC',
        value: 'Allowed envelope format identifiers shown in the Envelope Type dropdown.',
    },
    VALUE_LABEL: { key: 'MANAGE_PRINT_OPTION_CATALOG_VALUE_LABEL', value: 'Value' },
    DISPLAY_LABEL_LABEL: { key: 'MANAGE_PRINT_OPTION_CATALOG_DISPLAY_LABEL_LABEL', value: 'Display label' },
    VALUE_PLACEHOLDER_COLOR_MODE: {
        key: 'MANAGE_PRINT_OPTION_CATALOG_VALUE_PH_COLOR_MODE',
        value: 'Monochrome',
    },
    DISPLAY_LABEL_PLACEHOLDER_COLOR_MODE: {
        key: 'MANAGE_PRINT_OPTION_CATALOG_DISPLAY_PH_COLOR_MODE',
        value: 'Black & white',
    },
    VALUE_PLACEHOLDER_MAIL_TYPE: {
        key: 'MANAGE_PRINT_OPTION_CATALOG_VALUE_PH_MAIL_TYPE',
        value: 'Normal',
    },
    DISPLAY_LABEL_PLACEHOLDER_MAIL_TYPE: {
        key: 'MANAGE_PRINT_OPTION_CATALOG_DISPLAY_PH_MAIL_TYPE',
        value: 'Normal post',
    },
    VALUE_PLACEHOLDER_ENVELOPE_TYPE: {
        key: 'MANAGE_PRINT_OPTION_CATALOG_VALUE_PH_ENVELOPE',
        value: 'C5',
    },
    DISPLAY_LABEL_PLACEHOLDER_ENVELOPE_TYPE: {
        key: 'MANAGE_PRINT_OPTION_CATALOG_DISPLAY_PH_ENVELOPE',
        value: 'C5',
    },
    ADD_BUTTON: { key: 'MANAGE_PRINT_OPTION_CATALOG_ADD_BUTTON', value: 'Add' },
    COUNT_VALUES: { key: 'MANAGE_PRINT_OPTION_CATALOG_COUNT_VALUES', value: '{{count}} values' },
    MOVE_UP: { key: 'MANAGE_PRINT_OPTION_CATALOG_MOVE_UP', value: 'Move up' },
    MOVE_DOWN: { key: 'MANAGE_PRINT_OPTION_CATALOG_MOVE_DOWN', value: 'Move down' },
    DELETE: { key: 'MANAGE_PRINT_OPTION_CATALOG_DELETE', value: 'Delete' },
    DELETE_CONFIRM: {
        key: 'MANAGE_PRINT_OPTION_CATALOG_DELETE_CONFIRM',
        value: 'Delete this catalog entry?',
    },
    FIELD_REQUIRED: {
        key: 'MANAGE_PRINT_OPTION_CATALOG_FIELD_REQUIRED',
        value: 'Value and display label are required.',
    },
    FETCH_ERROR: {
        key: 'MANAGE_PRINT_OPTION_CATALOG_FETCH_ERROR',
        value: 'Unable to load print catalog. Please try again.',
    },
    SAVE_ERROR: {
        key: 'MANAGE_PRINT_OPTION_CATALOG_SAVE_ERROR',
        value: 'Unable to save changes. Please try again.',
    },
    ADD_SUCCESS: { key: 'MANAGE_PRINT_OPTION_CATALOG_ADD_SUCCESS', value: 'Entry added successfully.' },
    DELETE_SUCCESS: { key: 'MANAGE_PRINT_OPTION_CATALOG_DELETE_SUCCESS', value: 'Entry deleted successfully.' },
    REORDER_SUCCESS: { key: 'MANAGE_PRINT_OPTION_CATALOG_REORDER_SUCCESS', value: 'Order updated successfully.' },
    EMPTY_LIST: { key: 'MANAGE_PRINT_OPTION_CATALOG_EMPTY_LIST', value: 'No values yet. Add one below.' },
}

export const EFAX_CONFIGURATION_MODAL = {
  FIELD_REQUIRED_ERROR_MESSAGE: { key: 'FIELD_REQUIRED_ERROR_MESSAGE', value: 'Please fill in this required field.' },
  BEGINNING_SPACE_ERROR_MESSAGE: { key: 'BEGINNING_SPACE_ERROR_MESSAGE', value: 'Input must begin with a non-space character.' },
  NO_EDITS_PERFORMED_WARNING_MESSAGE: { key: 'NO_EDITS_PERFORMED_WARNING_MESSAGE', value: 'No edits have been performed' },
  UPDATED_SUCCESS_MESSAGE: { key: 'UPDATED_SUCCESS_MESSAGE', value: 'The configuration for fax has been successfully updated' },
  UPDATE_FAILED_ERROR_MESSAGE: { key: 'UPDATE_FAILED_ERROR_MESSAGE', value: 'The attempt to update Fax configuration failed' },
  ADDED_SUCCESS_MESSAGE: { key: 'ADDED_SUCCESS_MESSAGE', value: 'The fax configuration has been added successfully' },
  ADD_FAILED_ERROR_MESSAGE: { key: 'ADD_FAILED_ERROR_MESSAGE', value: 'Failed to add Fax configuration' },
  UPDATE_FAX_CONFIGURATION_TITLE: { key: 'UPDATE_FAX_CONFIGURATION_TITLE', value: 'Update Fax Configuration' },
  ADD_FAX_CONFIGURATION_TITLE: { key: 'ADD_FAX_CONFIGURATION_TITLE', value: 'Add Fax Configuration' },
  UPDATE_BUTTON: { key: 'UPDATE_BUTTON', value: 'Update' },
  ADD_BUTTON: { key: 'ADD_BUTTON', value: 'Add' },
  UPDATING_BUTTON: { key: 'UPDATING_BUTTON', value: 'Updating' },
  ADDING_BUTTON: { key: 'ADDING_BUTTON', value: 'Adding' },
  UNIQUE_CONFIGURATION_NAME_LABEL: { key: 'UNIQUE_CONFIGURATION_NAME_LABEL', value: 'Unique Configuration Name' },
  FAX_NUMBER_LABEL: { key: 'FAX_NUMBER_LABEL', value: 'Fax Number' },
  API_ID_LABEL: { key: 'API_ID_LABEL', value: 'API ID' },
  USER_ID_LABEL: { key: 'USER_ID_LABEL', value: 'User ID' },
  API_KEY_LABEL: { key: 'API_KEY_LABEL', value: 'API Key' }, 
  FAX_NUMBER_NOT_VALID_ERROR_MESSAGE: { key: 'FAX_NUMBER_NOT_VALID_ERROR_MESSAGE', value: 'The entered fax number is not valid.' },
  API_ID_HELP_TEXT: { key: 'API_ID_HELP_TEXT', value: 'API ID of the group whose credentials will be used for sending faxes' },
  USER_ID_HELP_TEXT: { key: 'USER_ID_HELP_TEXT', value: 'User ID for the user with whom the fax will be associated' },
  
    
}

export const MANAGE_LANGUAGE_SETTINGS = {
    MANAGE_LANGUAGE_SETTINGS_TITLE: { key: 'MANAGE_LANGUAGE_SETTINGS_TITLE', value: 'Manage language settings' },
    MANAGE_LANGUAGE_SETTINGS_DESCRIPTION: { key: 'MANAGE_LANGUAGE_SETTINGS_DESCRIPTION', value: 'Manage languages used for template translation' },
    ENTER_GOOGLE_API_KEY_MODAL_TITLE: { key: 'ENTER_GOOGLE_API_KEY_MODAL_TITLE', value: 'Enter new Google api key' },
    ENTER_GOOGLE_API_KEY_PLACEHOLDER: { key: 'ENTER_GOOGLE_API_KEY_PLACEHOLDER', value: 'Enter new Google api key' },
    MANAGE_AVAILABLE_LANGUAGES_LABEL: { key: 'MANAGE_AVAILABLE_LANGUAGES_LABEL', value: 'Languages enabled for your account' },
    EMPTY_LANGUAGES_WARNING_MESSAGE: { key: 'EMPTY_LANGUAGES_WARNING_MESSAGE', value: "Please select language" },
    GOOGLE_API_KEY_USED_LABEL: { key: 'GOOGLE_API_KEY_USED_LABEL', value: "Google API Key" },
    UPDATING_GOOGLE_API_KEY_SUCCESS_MESSAGE: { key: 'UPDATING_GOOGLE_API_KEY_SUCCESS_MESSAGE', value: "Google translate api activated!!" },
    GOOGLE_API_KEY_UPDATION_FAILED_ERROR_MESSAGE: { key: 'GOOGLE_API_KEY_UPDATION_FAILED_ERROR_MESSAGE', value: "Activation unsuccessful" },
    ADD_SELECTED_LANGUAGES_BUTTON: { key: 'ADD_SELECTED_LANGUAGES_BUTTON', value: "Add" },
    ACTIVATE_VALID_API_KEY_BUTTON: { key: 'ACTIVATE_VALID_API_KEY_BUTTON', value: "Activate Key" },
    FREE_PLAN_UPGRADE_MESSAGE: { key: 'FREE_PLAN_UPGRADE_MESSAGE', value: 'In this free plan, you can add only {{languageLimit}} language(s). Please upgrade to add more languages.' },
    STANDARD_PLAN_UPGRADE_MESSAGE: { key: 'STANDARD_PLAN_UPGRADE_MESSAGE', value: 'In this standard plan, you can only add up to {{languageLimit}} languages. Please consider upgrading to add more languages.' },
    PREMIUM_PLAN_UPGRADE_MESSAGE: { key: 'PREMIUM_PLAN_UPGRADE_MESSAGE', value: 'You have reached the limit for adding new languages under your current plan. To add more languages, you can upgrade to an enterprise plan. For assistance with upgrading, please contact our support team at <a href="mailto:{{emailId}}">{{emailId}}</a>.' },
    CHECKING_LANGUAGE_LIMIT_ERROR: { key: 'CHECKING_LANGUAGE_LIMIT_ERROR', value: 'Error while checking the language limit.' },
    PLEASE_WAIT_MESSAGE: { key: 'PLEASE_WAIT_MESSAGE', value: 'Please wait' },
    ADD_LANGUAGE_SUCCESS_MESSAGE: { key: 'ADD_LANGUAGE_SUCCESS_MESSAGE', value: 'Language added Successfully!' },
    ADD_LANGUAGE_SUCCESS_FAILURE: { key: 'ADD_LANGUAGE_SUCCESS_FAILURE', value: 'An error occured while trying to add language' },
    LANGUAGE_DELETED_SUCCESS_MESSAGE: { key: 'LANGUAGE_DELETED_SUCCESS_MESSAGE', value: 'Language deleted Successfully!' },
    LANGUAGE_DELETED_FAILURE_MESSAGE: { key: 'LANGUAGE_DELETED_FAILURE_MESSAGE', value: 'An error occured while trying to delete language' },
    DELETE_LANGUAGE_CONFIRMATION_MESSAGE: { key: 'DELETE_LANGUAGE_CONFIRMATION_MESSAGE', value: 'When deleting this language, all templates associated with it will no longer be accessible. Are you sure you wish to proceed with the deletion?' },
    DELETE_CONFIRM_BUTTON: { key: 'DELETE_CONFIRM_BUTTON', value: 'Delete' },
    ENABLED_LANGUAGES_LABEL: { key: 'ENABLED_LANGUAGES_LABEL', value: 'Enabled Languages' },
    ENABLE_LANGUAGE_TRANSLATION: { key: 'ENABLE_LANGUAGE_TRANSLATION', value: 'Enable language translation' },
    ENABLE_AI_WRITING: { key: 'ENABLE_AI_WRITING', value: 'Enable AI writing' },
    LANGUAGE_TRANSLATION_TOGGLE_SUCCESS: { key: 'LANGUAGE_TRANSLATION_TOGGLE_SUCCESS', value: 'Language translation updated successfully' },
    AI_WRITING_TOGGLE_SUCCESS: { key: 'AI_WRITING_TOGGLE_SUCCESS', value: 'AI writing updated successfully' },
    LANGUAGE_TRANSLATION_UPDATE_FAILED: { key: 'LANGUAGE_TRANSLATION_UPDATE_FAILED', value: 'An error occured while trying to toggle language translation' },
    AI_WRITING_UPDATE_FAILED: { key: 'AI_WRITING_UPDATE_FAILED', value: 'An error occured while trying to toggle AI writing' },
    AUTO_TRANSLATION_DISABLED_MESSAGE: { key: 'AUTO_TRANSLATION_DISABLED_MESSAGE', value: 'Auto translation feature is disabled.' },
    AI_WRITING_DISABLED_MESSAGE: { key: 'AI_WRITING_DISABLED_MESSAGE', value: 'Write for me feature is disabled.' },
    AUTO_TRANSLATION_DISABLE_CONFIRM_MESSAGE: { key: 'AUTO_TRANSLATION_DISABLE_CONFIRM_MESSAGE', value: 'Are you sure you want to turn off auto translation?' },
    AI_WRITING_DISABLE_CONFIRM_MESSAGE: { key: 'AI_WRITING_DISABLE_CONFIRM_MESSAGE', value: 'Are you sure you want to turn off Write for me feature?' },
    AUTO_TRANSLATION_ENABLE_SUCCESS_MESSAGE: { key: 'AUTO_TRANSLATION_ENABLE_SUCCESS_MESSAGE', value: 'Auto-translation enabled! Your templates can now support seamless translations.' },
    AI_WRITING_ENABLE_SUCCESS_MESSAGE: { key: 'AI_WRITING_ENABLE_SUCCESS_MESSAGE', value: 'Write for Me enabled! Select any topic or text and let AI craft compelling content for you.' },
    AUTO_TRANSLATION_FEATURE_LABEL: { key: 'AUTO_TRANSLATION_FEATURE_LABEL', value: 'Auto Translation Feature' },
    AI_WRITING_FEATURE_LABEL: { key: 'AI_WRITING_FEATURE_LABEL', value: 'Write For Me Feature' },
    AUTO_TRANSLATION_FEATURE_DESCRIPTION: { key: 'AUTO_TRANSLATION_FEATURE_DESCRIPTION', value: 'Create a template in one language and auto translate it to other languages on a single click!!' },
    AI_WRITING_FEATURE_DESCRIPTION: { key: 'AI_WRITING_FEATURE_DESCRIPTION', value: 'AI powered text generation to help you get started on a design from scratch!!' },
    PROCEED_BUTTON_LABEL: { key: 'PROCEED_BUTTON_LABEL', value: 'Proceed' },
}

export const MANAGE_LICENSE_SETTINGS = {
    COPY_SUBSCRIPTION_KEY_SUCCESSFUL_POPUP: { key: 'COPY_SUBSCRIPTION_KEY_SUCCESSFUL_POPUP', value: "Subscription Key copied to clipboard!" },
    VALID_NEW_ACTIVATION_KEY_SUCCESS_MESSAGE: { key: 'VALID_NEW_ACTIVATION_KEY_SUCCESS_MESSAGE', value: "New license activated!!" },
    INVALID_NEW_ACTIVATION_KEY_ERROR_MESSAGE: { key: 'INVALID_NEW_ACTIVATION_KEY_ERROR_MESSAGE', value: 'Activation unsuccessful :' },
    MANAGE_LICENSE_SETTINGS_TITLE: { key: 'MANAGE_LICENSE_SETTINGS_TITLE', value: 'Manage License' },
    MANAGE_LICENSE_ACTIVATION_KEY_LABEL: { key: 'MANAGE_LICENSE_ACTIVATION_KEY_LABEL', value: 'Activation Key' },
    MANAGE_LICENSE_SUBSCRIPTION_KEY_LABEL: { key: 'MANAGE_LICENSE_SUBSCRIPTION_KEY_LABEL', value: 'Subscription Key' },
    LICENSE_EXPIRY_DATE_LABEL: { key: 'LICENSE_EXPIRY_DATE_LABEL', value: 'License expires on' },
    LICENSE_EXPIRATION_TODAY_LABEL: { key: 'LICENSE_EXPIRATION_TODAY_LABEL', value: 'Expires today' },
    LICENSE_EXPIRATION_DAYS_TO_GO_LABEL: { key: 'LICENSE_EXPIRATION_DAYS_TO_GO_LABEL', value: 'days to expire' },
    MANAGE_LICENSE_SETTINGS_ENABLED_MODULES_LABEL: { key: 'MANAGE_LICENSE_SETTINGS_ENABLED_MODULES_LABEL', value: 'Enabled modules' },
    LICENSE_TRANSACTIONAL_NODES_ACTIVATED_LABEL: { key: 'LICENSE_TRANSACTIONAL_NODES_ACTIVATED_LABEL', value: 'Transactional nodes activated' },
    ENABLED_MODULE_DESIGN_SYSTEM_LABEL: { key: 'ENABLED_MODULE_DESIGN_SYSTEM_LABEL', value: 'Design system' },
    ENABLED_MODULE_DESIGN_SYSTEM_DESCRIPTION: { key: 'ENABLED_MODULE_DESIGN_SYSTEM_DESCRIPTION', value: 'Designing print and email templates or elements' },
    ENABLED_MODULE_TRANSACTIONAL_SYSTEM_LABEL: { key: 'ENABLED_MODULE_TRANSACTIONAL_SYSTEM_LABEL', value: 'Transactional system' },
    ENABLED_MODULE_TRANSACTIONAL_SYSTEM_DESCRIPTION: { key: 'ENABLED_MODULE_TRANSACTIONAL_SYSTEM_DESCRIPTION', value: 'Integrate with DocStudio to print PDFs and send emails' },
    ENABLED_MODULE_TRANSLATION_SYSTEM_LABEL: { key: 'ENABLED_MODULE_TRANSLATION_SYSTEM_LABEL', value: 'Translation system' },
    ENABLED_MODULE_TRANSLATION_SYSTEM_DESCRIPTION: { key: 'ENABLED_MODULE_TRANSLATION_SYSTEM_DESCRIPTION', value: 'Translate template or elements' },
    ENABLED_MODULE_MAIL_ROOM_LABEL: { key: 'ENABLED_MODULE_MAIL_ROOM_LABEL', value: 'license.mailRoomModule' },
    ENABLED_MODULE_MAIL_ROOM_DESCRIPTION: { key: 'ENABLED_MODULE_MAIL_ROOM_DESCRIPTION', value: 'license.mailRoomModule' },
    LICENSE_ACTIVATION_KEY_COLLECTION_MODAL_TITLE: { key: 'LICENSE_ACTIVATION_KEY_COLLECTION_MODAL_TITLE', value: 'Enter new Activation key' },
    RENEW_ACTIVATION_KEY_BUTTON: { key: 'RENEW_ACTIVATION_KEY_BUTTON', value: 'Renew License' },
    RENEWING_ACTIVATION_KEY_BUTTON: { key: 'RENEWING_ACTIVATION_KEY_BUTTON', value: 'Renewing License' },
}

export const SINGLE_SIGN_ON_SETTINGS = {
  SSO_SETTINGS_TITLE : { key: 'SSO_SETTINGS_TITLE', value: 'Manage Single Sign On' },
  SSO_TENANT_NAME : { key: 'SSO_TENANT_NAME', value: 'Tenant Name' },
  RAW_IDP_XML : { key: 'RAW_IDP_XML', value: 'Raw IdP XML'},
}

export const MANAGE_MULTI_CLOUD_STORAGE_SETTINGS = {
    MULTI_CLOUD_STORAGE_CONFIGURED_TOOLTIP: { key: 'MULTI_CLOUD_STORAGE_CONFIGURED_TOOLTIP', value: 'Configured' },
    MULTI_CLOUD_STORAGE_NOT_CONFIGURED_TOOLTIP: { key: 'MULTI_CLOUD_STORAGE_NOT_CONFIGURED_TOOLTIP', value: 'Not configured' },
    CONFIGURE_MULTI_CLOUD_STORAGE_SETTINGS_BUTTON: { key: 'CONFIGURE_MULTI_CLOUD_STORAGE_SETTINGS_BUTTON', value: 'Configure' },
    SERVICE_CONFIGURATION_DESCRIPTION_LABEL: { key: 'SERVICE_CONFIGURATION_DESCRIPTION_LABEL', value: 'Configure your service here.' },
    RESOURCE_CONFIGURATION_DESCRIPTION_LABEL: { key: 'RESOURCE_CONFIGURATION_DESCRIPTION_LABEL', value: 'Configure your resource here.' },
    MANAGE_MULTI_CLOUD_STORAGE_SETTINGS_TITLE: { key: 'MANAGE_MULTI_CLOUD_STORAGE_SETTINGS_TITLE', value: 'Manage multicloud storage settings' },
    MANAGE_MULTI_CLOUD_STORAGE_SETTINGS_DESCRIPTION: { key: 'MANAGE_MULTI_CLOUD_STORAGE_SETTINGS_DESCRIPTION', value: 'Manage multicloud storage settings here' },
    EXPLORE_MULTI_CLOUD_STORAGE_SERVICES_LABEL: { key: 'EXPLORE_MULTI_CLOUD_STORAGE_SERVICES_LABEL', value: 'Explore Services' },
    MULTI_CLOUD_STORAGE_RESOURCES_LABEL: { key: 'MULTI_CLOUD_STORAGE_RESOURCES_LABEL', value: 'Resources' },
    LOCAL_LABEL: { key: 'LOCAL_LABEL', value: 'Local' },
    STORAGE_DATA_FETCH_FAIL_ERROR: { key: 'STORAGE_DATA_FETCH_FAIL_ERROR', value: 'Error while fetching storage configuration data' },
    DEFAULT_LABEL: { key: 'DEFAULT_LABEL', value: 'default' },
    STORAGE_CONFIG_UPDATE_SUCCESS_MESSAGE: { key: 'STORAGE_CONFIG_UPDATE_SUCCESS_MESSAGE', value: 'Configurations updated successfully.' },
    STORAGE_CONFIG_UPDATE_ERROR_MESSAGE: { key: 'STORAGE_CONFIG_UPDATE_ERROR_MESSAGE', value: 'An error occurred while changing the storage service.' },
    RESOURCE_IMAGE_TITLE: { key: 'RESOURCE_IMAGE_TITLE', value: 'Images' },
    RESOURCE_TEMPLATE_TITLE: { key: 'RESOURCE_TEMPLATE_TITLE', value: 'Template Resources' },
    RESOURCE_FONTS_TITLE: { key: 'RESOURCE_FONTS_TITLE', value: 'Fonts' },
    RESOURCE_PROCESSED_FONTS_TITLE: { key: 'RESOURCE_PROCESSED_FONTS_TITLE', value: 'Processed PDFs' },
    RESOURCE_THUMBNAILS_TITLE: { key: 'RESOURCE_THUMBNAILS_TITLE', value: 'Thumbnails' },
    CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
    YES_CONFIRMATION_BUTTON: { key: 'YES_CONFIRMATION_BUTTON', value: 'Yes' },
    SWITCH_CONFIG_CONFIRMATION_MESSAGE: { key: 'SWITCH_CONFIG_CONFIRMATION_MESSAGE', value: 'Are you sure you would like to switch?' },
}

export const CLOUD_STORAGE_CONFIGURATION_MODAL = {
    UPDATE_CLOUD_STORAGE_CONFIGURATION_SUCCESS_MESSAGE: { key: 'UPDATE_CLOUD_STORAGE_CONFIGURATION_SUCCESS_MESSAGE', value: 'Storage Settings updated Successfully' },
    CANCEL_CLOUD_STORAGE_CONFIGURATION_BUTTON: { key: 'CANCEL_CLOUD_STORAGE_CONFIGURATION_BUTTON', value: 'Cancel' },
    SAVE_CLOUD_STORAGE_CONFIGURATION_BUTTON: { key: 'SAVE_CLOUD_STORAGE_CONFIGURATION_BUTTON', value: 'Save' },
    CLOUD_STORAGE_CONFIGURATION_MODAL_BACK_BUTTON: { key: 'CLOUD_STORAGE_CONFIGURATION_MODAL_BACK_BUTTON', value: 'Back' },
}

export const CLOUD_SERVICES_CONFIGURATION_MODAL = {
    CLOUD_SERVICES_CONFIGURATION_MODAL_TITLE: { key: 'CLOUD_SERVICES_CONFIGURATION_MODAL_TITLE', value: 'configuration' },
    CLOUD_SERVICES_CONFIGURATION_PLACEHOLDER: { key: 'CLOUD_SERVICES_CONFIGURATION_PLACEHOLDER', value: 'Enter your' },
}

export const CLOUD_RESOURCES_CONFIGURATION_MODAL = {
    CLOUD_RESOURCES_CONFIGURATION_MODAL_TITLE: { key: 'CLOUD_RESOURCES_CONFIGURATION_MODAL_TITLE', value: 'Resource configuration' },
    CLOUD_RESOURCE_CONFIGURATION_LABEL: { key: 'CLOUD_RESOURCE_CONFIGURATION_LABEL', value: 'Select a service' },
    CLOUD_RESOURCE_CONFIGURATION_PLACEHOLDER: { key: 'CLOUD_RESOURCE_CONFIGURATION_PLACEHOLDER', value: 'Select a service' },
    RESOURCES_CONFIGURATION_BUCKET_NAME_LABEL: { key: 'RESOURCES_CONFIGURATION_BUCKET_NAME_LABEL', value: 'Bucket name' },
    RESOURCES_CONFIGURATION_BUCKET_NAME_PLACEHOLDER: { key: 'RESOURCES_CONFIGURATION_BUCKET_NAME_PLACEHOLDER', value: 'Enter your bucket' },
}

export const MANAGE_PRINTER_SETTINGS = {
    MANAGE_PRINTER_SETTINGS_TITLE: { key: 'MANAGE_PRINTER_SETTINGS_TITLE', value: 'Manage printer configuration' },
    MANAGE_PRINTER_SETTINGS_DESCRIPTION: { key: 'MANAGE_PRINTER_SETTINGS_DESCRIPTION', value: 'Manage printer configuration here' },
    OPEN_MAPPING_MODAL_BUTTON: { key: 'OPEN_MAPPING_MODAL_BUTTON', value: 'Tag Mapping' },
    ADD_NEW_PRINTER_BUTTON: { key: 'ADD_NEW_PRINTER_BUTTON', value: 'Add Printer Config' },
    TEST_PRINTER_IS_WORKING_ACTION_TOOLTIP: { key: 'TEST_PRINTER_IS_WORKING_ACTION_TOOLTIP', value: 'Test Page' },
    TEST_PRINTER_CONNECTION_ACTION_TOOLTIP: { key: 'TEST_PRINTER_CONNECTION_ACTION_TOOLTIP', value: 'Test Print Connection' },
    VALID_PRINTER_TOOLTIP: { key: 'VALID_PRINTER_TOOLTIP', value: 'Valid Printer' },
    PRINTER_CONNECTION_TESTING_TOOLTIP: { key: 'PRINTER_CONNECTION_TESTING_TOOLTIP', value: 'Testing' },
    INVALID_PRINTER_TOOLTIP: { key: 'INVALID_PRINTER_TOOLTIP', value: 'Invalid printer' },
    DELETE_PRINTER_BUTTON: { key: 'DELETE_PRINTER_BUTTON', value: 'Delete' },
    DEFAULT_PRINTER_CHANGE_CONFIRMATION_TITLE: { key: 'DEFAULT_PRINTER_CHANGE_CONFIRMATION_TITLE', value: 'Are you sure to change the default printer?' },
    DEFAULT_PRINTER_CHANGE_CONFIRMATION_YES_BUTTON: { key: 'DEFAULT_PRINTER_CHANGE_CONFIRMATION_YES_BUTTON', value: 'Yes' },
    DEFAULT_PRINTER_CHANGE_CONFIRMATION_No_BUTTON: { key: 'DEFAULT_PRINTER_CHANGE_CONFIRMATION_No_BUTTON', value: 'No' },
    CHANGE_DEFAULT_PRINTER_TOOLTIP: { key: 'CHANGE_DEFAULT_PRINTER_TOOLTIP', value: 'Change default printer' },
    CURRENT_DEFAULT_PRINTER_TOOLTIP: { key: 'CURRENT_DEFAULT_PRINTER_TOOLTIP', value: 'Default Printer' },
    CURRENT_DEFAULT_PRINTER_ACTION: { key: 'CURRENT_DEFAULT_PRINTER_ACTION', value: 'Default' },
    CANCEL_NEW_PRINTER_CONFIGURATION_BUTTON: { key: 'CANCEL_NEW_PRINTER_CONFIGURATION_BUTTON', value: 'Cancel' },
    SET_DEFAULT_PRINTER_SUCCESS: { key: 'SET_DEFAULT_PRINTER_SUCCESS', value: 'set default printer successfully'},
    SET_DEFAULT_PRINTER_FAILURE: { key: 'SET_DEFAULT_PRINTER_FAILURE', value: 'Failed to set default printer'},
}

export const ADD_NEW_PRINTER_CONFIGURATION_MODAL = {
    EMPTY_IP_ADDRESS_WARNING_MESSAGE: { key: 'EMPTY_IP_ADDRESS_WARNING_MESSAGE', value: 'Please Enter the valid IP Address' },
    INVALID_PRINTER_NAME_WARNING_MESSAGE: { key: 'INVALID_PRINTER_NAME_WARNING_MESSAGE', value: 'Printer Name cannot contain' },
    PRINTER_NAME_EXCEDED_MAXIMUM_LENGTH_WARNING_MESSAGE: { key: 'PRINTER_NAME_EXCEDED_MAXIMUM_LENGTH_WARNING_MESSAGE', value: 'Printer Name can have only max of 127 characters' },
    NEW_PRINTER_ADDED_SUCCESS_MESSAGE: { key: 'NEW_PRINTER_ADDED_SUCCESS_MESSAGE', value: 'Printer Added Successfully!' },
    NEW_PRINTER_CONNECTION_VALIDATION_SUCCESS_MESSAGE: { key: 'NEW_PRINTER_CONNECTION_VALIDATION_SUCCESS_MESSAGE', value: 'This is a valid printer configuration' },
    EMPTY_PRINTER_NAME_WARNING_MESSAGE: { key: 'EMPTY_PRINTER_NAME_WARNING_MESSAGE', value: 'Please Enter a valid Printer Name' },
    ADD_NEW_PRINTER_CONFIGURATION_MODAL_TITLE: { key: 'ADD_NEW_PRINTER_CONFIGURATION_MODAL_TITLE', value: 'Add Printer Config' },
    ADD_NEW_TESTED_PRINTER_BUTTON: { key: 'ADD_NEW_TESTED_PRINTER_BUTTON', value: 'Add' },
    TEST_NEW_PRINTER_CONNECTION_BUTTON: { key: 'TEST_NEW_PRINTER_CONNECTION_BUTTON', value: 'Test Connection' },
    ADD_NEW_PRINTER_NAME_LABEL: { key: 'ADD_NEW_PRINTER_NAME_LABEL', value: 'Printer Name' },
    ADD_NEW_PRINTER_NAME_PLACEHOLDER: { key: 'ADD_NEW_PRINTER_NAME_PLACEHOLDER', value: 'Printer Name' },
    ADD_NEW_IP_ADDRESS_LABEL: { key: 'ADD_NEW_IP_ADDRESS_LABEL', value: 'IP Address' },
    ADD_NEW_IP_ADDRESS_PLACEHOLDER: { key: 'ADD_NEW_IP_ADDRESS_PLACEHOLDER', value: 'IP Address' },
}

export const TAG_MAPPING_MODAL = {
    TAG_MAPPING_MODAL_TITLE: { key: 'TAG_MAPPING_MODAL_TITLE', value: 'Tag mapping' },
    TAG_ID_COLUMN_LABEL: { key: 'TAG_ID_COLUMN_LABEL', value: 'Tag Id' },
    TAG_NAME_COLUMN_LABEL: { key: 'TAG_NAME_COLUMN_LABEL', value: 'Tag Name' },
    CREATED_ON_COLUMN_LABEL: { key: 'CREATED_ON_COLUMN_LABEL', value: 'Created On' },
    ACTION_COLUMN_LABEL: { key: 'ACTION_COLUMN_LABEL', value: 'Action' },
    EDIT_TAG_CONFIRMATION_POPUP_TITLE: { key: 'EDIT_TAG_CONFIRMATION_POPUP_TITLE', value: 'Sure to change the tag name?' },
    EDIT_TAG_CONFIRMATION_POPUP_NOTE_DESCRIPTION: { key: 'EDIT_TAG_CONFIRMATION_POPUP_NOTE_DESCRIPTION', value: '(Note: Changing the tag name will affect the associated templates too)' },
    CANCEL_TAG_CHANGES_POPUP_TITLE: { key: 'CANCEL_TAG_CHANGES_POPUP_TITLE', value: 'Sure to Cancel?' },
    DELETE_TAG_TITLE: { key: 'DELETE_TAG_TITLE', value: 'Sure to Delete?' },
    CONFIRM_UPDATE_ACTION: { key: 'CONFIRM_UPDATE_ACTION', value: 'Yes' },
    CONFIRM_CANCEL_ACTION: { key: 'CONFIRM_CANCEL_ACTION', value: 'Yes' },
    CONFIRM_DELETE_ACTION: { key: 'CONFIRM_DELETE_ACTION', value: 'Yes' },
    DECLINE_UPDATE_ACTION: { key: 'DECLINE_UPDATE_ACTION', value: 'No' },
    DECLINE_CANCEL_ACTION: { key: 'DECLINE_CANCEL_ACTION', value: 'No' },
    DECLINE_DELETE_ACTION: { key: 'DECLINE_DELETE_ACTION', value: 'No' },
    SHOW_COFIRMATION_POPUP_TO_UPDATE_TAG_ACTION: { key: 'SHOW_COFIRMATION_POPUP_TO_UPDATE_TAG_ACTION', value: 'Update' },
    CANCEL_CURRENT_CHANGES_MADE_TO_TAG_ACTION: { key: 'CANCEL_CURRENT_CHANGES_MADE_TO_TAG_ACTION', value: 'Cancel' },
    DELETE_TAG_ACTION: { key: 'DELETE_TAG_ACTION', value: 'Delete' },
    EDIT_TAG_ROW: { key: 'EDIT_TAG_ROW', value: 'Edit' },
    SELECT_TAG_ID_PLACEHOLDER: { key: 'SELECT_TAG_ID_PLACEHOLDER', value: 'Select a tagId' },
    ADD_NEW_TAG_BUTTON: { key: 'ADD_NEW_TAG_BUTTON', value: 'Add Tag' },
    ADD_NEW_TAG_ACTION: { key: 'ADD_NEW_TAG_ACTION', value: 'Add' },
    EMPTY_TAG_NAME_COLUMN_WARNING_MESSAGE: { key: 'EMPTY_TAG_NAME_COLUMN_WARNING_MESSAGE', value: 'Please enter the' },
}

export const MANAGE_SMTP_SERVER_CONFIGURATION = {
    MANAGE_SMTP_SERVER_CONFIGURATION_TITLE: { key: 'MANAGE_SMTP_SERVER_CONFIGURATION_TITLE', value: 'Manage SMTP Server Details' },
    MANAGE_SMTP_SERVER_CONFIGURATION_DESCRIPTION: { key: 'MANAGE_SMTP_SERVER_CONFIGURATION_DESCRIPTION', value: 'Manage SMTP Server Details here' },
    ADD_NEW_SMTP_SERVER_CONFIGURATION_MODAL_BUTTON: { key: 'ADD_NEW_SMTP_SERVER_CONFIGURATION_MODAL_BUTTON', value: 'Configure Custom SMTP' },
    CANCEL_DEFAULT_SMTP_CHANGES_BUTTON: { key: 'CANCEL_DEFAULT_SMTP_CHANGES_BUTTON', value: 'Cancel' },
    CHANGE_DEFAULT_SMTP_SERVER_ACTION: { key: 'CHANGE_DEFAULT_SMTP_SERVER_ACTION', value: 'Default' },
    CHANGE_DEFAULT_SMTP_SERVER_TOOLTIP: { key: 'CHANGE_DEFAULT_SMTP_SERVER_TOOLTIP', value: 'Change default SMTP' },
    CURRENT_DEFAULT_SMTP_SERVER_TOOLTIP: { key: 'CURRENT_DEFAULT_SMTP_SERVER_TOOLTIP', value: 'Default SMTP Server' },
    CONFIRM_DEFAULT_SMTP_SERVER_BUTTON: { key: 'CONFIRM_DEFAULT_SMTP_SERVER_BUTTON', value: 'Yes' },
    DECLINE_DEFAULT_SMTP_SERVER_BUTTON: { key: 'DECLINE_DEFAULT_SMTP_SERVER_BUTTON', value: 'No' },
    CHANGE_DEFAULT_SMTP_SERVER_CONFIRMATION_POPUP_TITLE: { key: 'CHANGE_DEFAULT_SMTP_SERVER_CONFIRMATION_POPUP_TITLE', value: 'Are you sure to change the default SMTP server?' },
    EDIT_SMTP_SERVER_TOOLTIP: { key: 'EDIT_SMTP_SERVER_TOOLTIP', value: 'Edit' },
    DELETE_SMTP_SERVER_TOOLTIP: { key: 'DELETE_SMTP_SERVER_TOOLTIP', value: 'Delete' },
    SMTP_SERVER_METRICS_LABEL: { key: 'SMTP_SERVER_METRICS_LABEL', value: 'METRICS' },
    DELETE_CONFIRMATION_MESSAGE: { key: 'DELETE_CONFIRMATION_MESSAGE', value: 'Are you sure you want to delete this ?' },
    DNS_PROVIDER_COPY_BUTTON: { key: 'DNS_PROVIDER_COPY_BUTTON', value: 'Copy' },
    COPY_TO_CLIPBOARD_TOOLTIP: { key: 'COPY_TO_CLIPBOARD_TOOLTIP', value: 'Copy to clipboard' },
    ENTER_FROM_ADDRESS_PLACEHOLDER: { key: 'ENTER_FROM_ADDRESS_PLACEHOLDER', value: 'Enter from address' },
    DOMAIN_VERIFY_BUTTON: { key: 'DOMAIN_VERIFY_BUTTON', value: 'Verify' },
    ADD_FROM_ADDRESS_BUTTON: { key: 'ADD_FROM_ADDRESS_BUTTON', value: 'Add' },
    DNS_HOSTNAME_LABEL: { key: 'DNS_HOSTNAME_LABEL', value: 'Host' },
    DNS_VALUE_LABEL: { key: 'DNS_VALUE_LABEL', value: 'Value' },
    FREE_PLAN_CANNOT_ADD_DOMAIN_ERROR: { key: 'FREE_PLAN_CANNOT_ADD_DOMAIN_ERROR', value: 'The free plan cannot add a domain.' },
    INVALID_FROM_ADDRESS_ERROR: { key: 'INVALID_FROM_ADDRESS_ERROR', value: 'Invalid from address!' },
    STANDARD_PLAN_LIMIT_REACHED_ERROR: { key: 'STANDARD_PLAN_LIMIT_REACHED_ERROR', value: 'A Standard user can only add one domains.' },
    PREMIUM_PLAN_LIMIT_REACHED_ERROR: { key: 'PREMIUM_PLAN_LIMIT_REACHED_ERROR', value: 'A premium user can only add two domains.' },
    HOSTNAME_VALUE_VERIFY_ERROR: { key: 'HOSTNAME_VALUE_VERIFY_ERROR', value: 'Please verify the hostname and value' },
    COPIED_INFO_MESSAGE: { key: 'COPIED_INFO_MESSAGE', value: 'Copied' },
    SMTP_VALIDATION_SUCCESS_MESSAGE: { key: 'SMTP_VALIDATION_SUCCESS_MESSAGE', value: 'SMTP configuration validated successfully.' },
    SMTP_VALIDATION_ERROR_MESSAGE: { key: 'SMTP_VALIDATION_ERROR_MESSAGE', value: 'An error occurred while validating SMTP configuration.' },
    VALIDATE_BUTTON: { key: 'VALIDATE_BUTTON', value: 'Validate' },
    ADD_FROM_ADDRESS_TEXT: { key: 'ADD_FROM_ADDRESS_TEXT', value: 'Add from address' },
    DELETE_BUTTON: { key: 'DELETE_BUTTON', value: 'delete' },
    VERIFY_BUTTON_TOOLTIP: { key: 'VERIFY_BUTTON_TOOLTIP', value: 'You should verify the domain if you want to use from address' },
    VERIFY_BUTTON: { key: 'VERIFY_BUTTON', value: 'verify' },
    VERIFY_DOMAIN_MODAL_TITLE: { key: 'VERIFY_DOMAIN_MODAL_TITLE', value: 'Verify domain' },
    ADD_HOSTNAME_ALERT_MESSAGE: { key: 'ADD_HOSTNAME_ALERT_MESSAGE', value: 'Add the TXT records, Hostnames, and Values for this domain in the settings section of your DNS provider.' },
    MANAGE_SMTP_SERVER_FROM_ADDRESS_LABEL: { key: 'MANAGE_SMTP_SERVER_FROM_ADDRESS_LABEL', value: 'From address' },
    MANAGE_SMTP_SERVER_ACTION_LABEL: { key: 'MANAGE_SMTP_SERVER_ACTION_LABEL', value: 'Action' },
    MANAGE_SMTP_SERVER_OK_LABEL: { key: 'MANAGE_SMTP_SERVER_OK_LABEL', value: 'OK' },
    SMTP_CONFIG_REMOVED_SUCCESSFULLY: { key: 'SMTP_CONFIG_REMOVED_SUCCESSFULLY', value: 'Smtp configuration deleted successfully' },
    DEFAULT_SMTP_UPDATED_SUCCESFULLY: { key: 'DEFAULT_SMTP_UPDATED_SUCCESFULLY', value: 'Default SMTP Updated Successfully' },
    UNABLE_TO_UPDATE_DEFAULT_SMTP: { key: 'UNABLE_TO_UPDATE_DEFAULT_SMTP', value: 'Unable to update the default SMTP' },
    FAILED_TO_DELETE_SMTP_CONFIGURATION: { key: 'FAILED_TO_DELETE_SMTP_CONFIGURATION', value: 'Failed to delete SMTP server configuration' },
    FAILED_TO_ADD_FROM_ADDRESS: { key: 'FAILED_TO_ADD_FROM_ADDRESS', value: 'Failed to add from address' },
    FROM_ADDRESS_LIMIT_REACHED: { key: 'FROM_ADDRESS_LIMIT_REACHED', value: 'You have reached your from address limit in your plan' }

}

export const ADD_OR_UPDATE_SMTP_SERVER_MODAL = {
    SMTP_SERVER_HOST_LABEL: { key: 'SMTP_SERVER_HOST_LABEL', value: 'Host' },
    SMTP_SERVER_HOST_PLACEHOLDER: { key: 'SMTP_SERVER_HOST_PLACEHOLDER', value: 'Host' },
    SMTP_SERVER_FROM_ADDRESS_LABEL: { key: 'SMTP_SERVER_FROM_ADDRESS_LABEL', value: 'From Address' },
    SMTP_SERVER_FROM_ADDRESS_PLACEHOLDER: { key: 'SMTP_SERVER_FROM_ADDRESS_PLACEHOLDER', value: 'From Address' },
    SMTP_SERVER_USERNAME_LABEL: { key: 'SMTP_SERVER_USERNAME_LABEL', value: 'UserName' },
    SMTP_SERVER_USERNAME_PLACEHOLDER: { key: 'SMTP_SERVER_USERNAME_PLACEHOLDER', value: 'UserName' },
    SMTP_SERVER_PASSWORD_LABEL: { key: 'SMTP_SERVER_PASSWORD_LABEL', value: 'Password' },
    SMTP_SERVER_PASSWORD_PLACEHOLDER: { key: 'SMTP_SERVER_PASSWORD_PLACEHOLDER', value: 'Password' },
    SMTP_SERVER_PROTOCOL_LABEL: { key: 'SMTP_SERVER_PROTOCOL_LABEL', value: 'Protocol' },
    SMTP_SERVER_PROTOCOL_SSL_RADIO_BUTTON: { key: 'SMTP_SERVER_PROTOCOL_SSL_RADIO_BUTTON', value: 'SSL' },
    SMTP_SERVER_PROTOCOL_TLS_RADIO_BUTTON: { key: 'SMTP_SERVER_PROTOCOL_TLS_RADIO_BUTTON', value: 'TLS' },
    SMTP_SERVER_PORT_LABEL: { key: 'SMTP_SERVER_PORT_LABEL', value: 'Port' },
    SMTP_SERVER_PORT_PLACEHOLDER: { key: 'SMTP_SERVER_PORT_PLACEHOLDER', value: 'Port' },
    EMPTY_SMTP_SERVER_HOST_WARNING_MESSAGE: { key: 'EMPTY_SMTP_SERVER_HOST_WARNING_MESSAGE', value: 'Please Enter the Host' },
    EMPTY_SMTP_SERVER_FROM_ADDRESS_WARNING_MESSAGE: { key: 'EMPTY_SMTP_SERVER_FROM_ADDRESS_WARNING_MESSAGE', value: 'Please Enter the From Address' },
    EMPTY_SMTP_SERVER_USERNAME_WARNING_MESSAGE: { key: 'EMPTY_SMTP_SERVER_USERNAME_WARNING_MESSAGE', value: 'Please Enter the UserName' },
    EMPTY_SMTP_SERVER_PASSWORD_WARNING_MESSAGE: { key: 'EMPTY_SMTP_SERVER_PASSWORD_WARNING_MESSAGE', value: 'Please Enter the Password' },
    EMPTY_SMTP_SERVER_PORT_WARNING_MESSAGE: { key: 'EMPTY_SMTP_SERVER_PORT_WARNING_MESSAGE', value: 'Please Enter the Port' },
    INVALID_SMTP_SERVER_FROM_ADDRESS_WARNING_MESSAGE: { key: 'INVALID_SMTP_SERVER_FROM_ADDRESS_WARNING_MESSAGE', value: 'From Address is invalid' },
    UPDATE_SMTP_SERVER_SUCCESS_MESSAGE: { key: 'UPDATE_SMTP_SERVER_SUCCESS_MESSAGE', value: 'SMTP Server Configuration updated successfully' },
    INVALID_SMTP_SERVER_CREDENTIALS_ERROR_MESSAGE: { key: 'INVALID_SMTP_SERVER_CREDENTIALS_ERROR_MESSAGE', value: 'Unable to reach SMTP server, Please check your credentials' },
    SMTP_SERVER_NOT_FOUND_ERROR_MESSAGE: { key: 'SMTP_SERVER_NOT_FOUND_ERROR_MESSAGE', value: 'Unable to reach SMTP server, No such provider' },
    UNREACHABLE_SMTP_SERVER_MESSAGING_EXCEPTION_ERROR_MESSAGE: { key: 'UNREACHABLE_SMTP_SERVER_MESSAGING_EXCEPTION_ERROR_MESSAGE', value: 'Unable to reach SMTP server, Messaging exception' },
    USER_OR_FROM_ADDRESS_ALREADY_EXIST_WARNING_MESSAGE: { key: 'USER_OR_FROM_ADDRESS_ALREADY_EXIST_WARNING_MESSAGE', value: 'From Address or UserName already Exists' },
    EDIT_SMTP_SERVER_MODAL_TITLE: { key: 'EDIT_SMTP_SERVER_MODAL_TITLE', value: 'Edit SMTP Server Config' },
    UPDATE_SMTP_SERVER_BUTTON: { key: 'UPDATE_SMTP_SERVER_BUTTON', value: 'Update' },
    ADD_NEW_SMTP_SERVER_BUTTON: { key: 'ADD_NEW_SMTP_SERVER_BUTTON', value: 'Add' },
    ADD_NEW_SMTP_SERVER_SUCCESS_MESSAGE: { key: 'ADD_NEW_SMTP_SERVER_SUCCESS_MESSAGE', value: 'SMTP Server created successfully' },
    ADD_SMTP_SERVER_MODAL_TITLE: { key: 'ADD_SMTP_SERVER_MODAL_TITLE', value: 'Add SMTP Server' },
}

export const MANAGE_TEAM_SETTINGS = {
    MANAGE_TEAM_SETTINGS_TITLE: { key: 'MANAGE_TEAM_SETTINGS_TITLE', value: 'Manage Teams' },
    MANAGE_TEAM_SETTINGS_DESCRIPTION: { key: 'MANAGE_TEAM_SETTINGS_DESCRIPTION', value: 'Manage teams here' },
    WAIT_TO_ADD_TEAM_BUTTON: { key: 'WAIT_TO_ADD_TEAM_BUTTON', value: 'Please wait' },//Adding team
    ADD_TEAM_BUTTON: { key: 'ADD_TEAM_BUTTON', value: 'Add team' },
    TEAM_INFORMATION_TOOLTIP: { key: 'TEAM_INFORMATION_TOOLTIP', value: 'Users under team' },
    EDIT_TEAM_BUTTON_TOOTLTIP: { key: 'EDIT_TEAM_BUTTON_TOOTLTIP', value: 'Edit team' },
    USER_READ_ACCESS_POPUP_LABEL: { key: 'USER_READ_ACCESS_POPUP_LABEL', value: 'User has read only access to team' },
    USER_FULL_ACCESS_POPUP_LABEL: { key: 'USER_FULL_ACCESS_POPUP_LABEL', value: 'User has full access to team' },
    NUMBER_OF_USERS_LABEL: { key: 'NUMBER_OF_USERS_LABEL', value: 'Users' },
    EMPTY_USERS_LIST_LABEL: { key: 'EMPTY_USERS_LIST_LABEL', value: 'No Users' },
    DELETE_TEAM_TOOLTIP: { key: 'DELETE_TEAM_TOOLTIP', value: 'Delete team' },
    FREE_PLAN_UPGRADE_MESSAGE: { key: 'FREE_PLAN_UPGRADE_MESSAGE', value: 'In your free plan, you are limited to adding just {{teamLimit}} team(s). To add more teams, please upgrade your plan.' },
    STANDARD_PLAN_UPGRADE_MESSAGE: { key: 'STANDARD_PLAN_UPGRADE_MESSAGE', value: 'In your standard plan, you are limited to adding just {{teamLimit}} teams. To add more teams, please upgrade your plan.' },
    PREMIUM_PLAN_LIMIT_REACHED_ERROR: { key: 'PREMIUM_PLAN_LIMIT_REACHED_ERROR' , value: "You have reached the limit for adding teams under your current plan. To add more teams, you can upgrade to an enterprise plan. For assistance with upgrading, please contact our support team at <a href='mailto:{{emailId}}'>{{emailId}}</a>." },
    CHECKING_TEAM_LIMIT_ERROR: { key: 'CHECKING_TEAM_LIMIT_ERROR', value: 'Error while checking the team limit.' },
}

export const MANAGE_TEAM_MODAL = {
    CANCEL_TEAM_BUTTON: { key: 'CANCEL_TEAM_BUTTON', value: 'Cancel' },
    TEAM_NAME_LABEL: { key: 'TEAM_NAME_LABEL', value: 'Team Name' },
    TEAM_NAME_PLACEHOLDER: { key: 'TEAM_NAME_PLACEHOLDER', value: 'Team Name ' },
    EMPTY_OR_USED_TEAM_NAME_WARNING_MESSAGE: { key: 'EMPTY_OR_USED_TEAM_NAME_WARNING_MESSAGE', value: 'Team Name can not be null and should be Unique' },
}

export const ADD_TEAM_MODAL = {
    ADD_TEAM_MODAL_TITLE: { key: 'ADD_TEAM_MODAL_TITLE', value: 'Add team' },
    ADD_NEW_TEAM_BUTTON: { key: 'ADD_NEW_TEAM_BUTTON', value: 'Add team' },
    ADDING_NEW_TEAM_BUTTON: { key: 'ADDING_NEW_TEAM_BUTTON', value: 'Adding team' },
    ADD_NEW_TEAM_SUCCESS_MESSAGE: { key: 'ADD_NEW_TEAM_SUCCESS_MESSAGE', value: 'Team added successfully' },
}

export const UPDATE_TEAM_MODAL = {
    UPDATE_TEAM_MODAL_TITLE: { key: 'UPDATE_TEAM_MODAL_TITLE', value: 'Update team' },
    UPDATE_NEW_TEAM_BUTTON: { key: 'UPDATE_NEW_TEAM_BUTTON', value: 'Update team' },
    UPDATING_NEW_TEAM_BUTTON: { key: 'UPDATING_NEW_TEAM_BUTTON', value: 'Updating team' },
    TEAM_UPDATED_SUCCESS_MESSAGE: { key: 'TEAM_UPDATED_SUCCESS_MESSAGE', value: 'Team updated successfully' },
}

export const DELETE_FAX_PRINTER_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL = {
    CANCEL_DELETE_CONFIGURATIONS_BUTTON: { key: 'CANCEL_DELETE_CONFIGURATIONS_BUTTON', value: 'Cancel' },
    DELETE_ADMIN_CONFIGURATIONS_CONFIRMATION_MODAL_DELETING_BUTTON: { key: 'DELETE_ADMIN_CONFIGURATIONS_CONFIRMATION_MODAL_DELETING_BUTTON', value: 'Deleting' },
    DELETE_ADMIN_CONFIGURATIONS_CONFIRMATION_MODAL_DELETE_BUTTON: { key: 'DELETE_ADMIN_CONFIGURATIONS_CONFIRMATION_MODAL_DELETE_BUTTON', value: 'Delete' },
}

export const DELETE_FAX_CONFIGURATIONS_CONFIRMATION_MODAL = {
    DELETE_FAX_CONFIGURATION_SUCCESS_MESSAGE: { key: 'DELETE_FAX_CONFIGURATION_SUCCESS_MESSAGE', value: 'Fax configuration has been successfully deleted' },
    DELETE_FAX_CONFIGURATION_ERROR_MESSAGE: { key: 'DELETE_FAX_CONFIGURATION_ERROR_MESSAGE', value: 'An error occurred while trying to delete the fax configuration' },
    DELETE_FAX_CONFIGURATION_MODAL_TITLE: { key: 'DELETE_FAX_CONFIGURATION_MODAL_TITLE', value: 'Delete Fax Configuration' },
    SURE_TO_DELETE_FAX_CONFIRMATION_MESSAGE: { key: 'SURE_TO_DELETE_FAX_CONFIRMATION_MESSAGE', value: 'Are you sure you want to delete the fax configuration' },
}

export const DELETE_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL = {
    DELETE_SMTP_CONFIGURATION_MODAL_TITLE: { key: 'DELETE_SMTP_CONFIGURATION_MODAL_TITLE', value: 'Delete SMTP Config' },
    SURE_TO_DELETE_SMTP_CONFIRMATION_TITLE: { key: 'SURE_TO_DELETE_SMTP_CONFIRMATION_TITLE', value: 'Are you sure you wish to delete the SMTP config' },
    DELETE_SMTP_CONFIGURATION_SUCCESS_MESSAGE: { key: 'DELETE_SMTP_CONFIGURATION_SUCCESS_MESSAGE', value: 'SMTP Server configuration deleted successfully' },
    DELETE_SMTP_CONFIGURATION_FAILURE_MESSAGE: { key: 'DELETE_SMTP_CONFIGURATION_FAILURE_MESSAGE', value: 'An error occured while trying to delete SMTP server configuration' },
}

export const DELETE_PRINTER_CONFIGURATIONS_CONFIRMATION_MODAL = {
    DELETE_PRINTER_CONFIGURATION_MODAL_TITLE: { key: 'DELETE_PRINTER_CONFIGURATION_MODAL_TITLE', value: 'Delete Printer Config' },
    SURE_TO_DELETE_PRINTER_CONFIRMATION_TITLE: { key: 'SURE_TO_DELETE_PRINTER_CONFIRMATION_TITLE', value: 'Are you sure you wish to delete the printer config' },
    DELETE_PRINTER_CONFIGURATION_SUCCESS_MESSAGE: { key: 'DELETE_PRINTER_CONFIGURATION_SUCCESS_MESSAGE', value: 'Printer configuration deleted successfully' },
    DELETE_PRINTER_CONFIGURATION_FAILURE_MESSAGE: { key: 'DELETE_PRINTER_CONFIGURATION_FAILURE_MESSAGE', value: 'An error occured while trying to delete printer configuration' },
}

export const MANAGE_USERS = {
    MANAGE_USERS_TITLE: { key: 'MANAGE_USERS_TITLE', value: 'Manage Users' },
    MANAGE_USERS_DESCRIPTION: {
        key: 'MANAGE_USERS_DESCRIPTION',
        value: 'Invite users and Manage their accounts here',
    },
    EDIT_CONFIGURATION_BUTTON: { key: 'EDIT_CONFIGURATION_BUTTON', value: 'Edit Config' },
    CONFIGURE_LDAP_BUTTON: { key: 'CONFIGURE_LDAP_BUTTON', value: 'Config LDAP' },
    INVITE_USER_BUTTON: { key: 'INVITE_USER_BUTTON', value: 'Invite User' },
    RESEND_INVITE_BUTTON: { key: 'RESEND_INVITE_BUTTON', value: 'Resend Invite' },
    PLEASE_WAIT_BUTTON: { key: 'PLEASE_WAIT_BUTTON', value: 'Please Wait' },
    RESENDING_INVITE_MESSAGE: { key: 'RESENDING_INVITE_MESSAGE', value: 'Resending Invite' },
    EDIT_USER_OPTION: { key: 'EDIT_USER_OPTION', value: 'Edit' },
    DELETE_USER_OPTION: { key: 'DELETE_USER_OPTION', value: 'Delete' },
    FREE_PLAN_UPGRADE_MESSAGE: {
      key: 'FREE_PLAN_UPGRADE_MESSAGE',
      value: 'In your free plan, you are limited to adding just {{userCount}} user(s). To invite additional users to your team, please upgrade your account.'
    },
    STANDARD_PLAN_UPGRADE_MESSAGE: {
      key: 'STANDARD_PLAN_UPGRADE_MESSAGE',
      value: 'In your standard plan, you are limited to adding just {{userCount}} users. To invite additional users to your team, please upgrade your account.'
    },
    PREMIUM_USER_LIMIT_REACHED: {
      key: 'PREMIUM_USER_LIMIT_REACHED',
      value: 'You have reached the limit for adding users under your current plan. To add more users, you can upgrade to an enterprise plan. For assistance with upgrading, please contact our support team at <a href="mailto:{{emailId}}">{{emailId}}</a>.'
    },
    ERROR_CHECKING_USER_LIMIT: {
      key: 'ERROR_CHECKING_USER_LIMIT',
      value: 'Error while checking the user limit.'
    },
    REINVITE_SUCCESS_MESSAGE: { key: 'REINVITE_SUCCESS_MESSAGE', value: 'User has been invited successfully.' },
    PRIMARY_TAG: { key: 'PRIMARY_TAG', value: 'Primary' },
    MASTER_TAG: { key: 'MASTER_TAG', value: 'Master' },
    PRIMARY_USER_DELETE_ERROR: { key: 'PRIMARY_USER_DELETE_ERROR', value: 'The primary user cannot be deleted.' },
    ADMIN_ROLE: { key: 'ADMIN_ROLE', value: 'Admin' },
    PUBLISHER_ROLE: { key: 'PUBLISHER_ROLE', value: 'Publisher' },
    DESIGNER_ROLE: { key: 'DESIGNER_ROLE', value: 'Designer' },
    MAIL_ROOM_ADMIN_ROLE: { key: 'MAIL_ROOM_ADMIN_ROLE', value: 'Mail Room Admin' },
    MAIL_ROOM_CLIENT_ROLE: { key: 'MAIL_ROOM_CLIENT_ROLE', value: 'Mail Room Client' },
    CONTACT_MANAGER_ROLE: { key: 'CONTACT_MANAGER_ROLE', value: 'Contact Manager' },
    CAMPAIGN_MANAGER_ROLE: { key: 'CAMPAIGN_MANAGER_ROLE', value: 'Campaign Manager' },
    JOB_APPROVER_L1: { key: 'JOB_APPROVER_L1', value: 'Job Approver L1' },
    JOB_APPROVER_L2: { key: 'JOB_APPROVER_L2', value: 'Job Approver L2' },
    JOB_APPROVER_L3: { key: 'JOB_APPROVER_L3', value: 'Job Approver L3' },
    JOB_APPROVER_L4: { key: 'JOB_APPROVER_L4', value: 'Job Approver L4' },
    JOB_MANAGER: { key: 'JOB_MANAGER', value: 'Job Manager' },
    WORKFLOW_MANAGER: { key: 'WORKFLOW_MANAGER', value: 'Workflow Manager' },
    ID_EDITOR: { key: 'ID_EDITOR', value: 'ID Editor' },
    REUSABLE_CONTENT_MANAGER: { key: 'REUSABLE_CONTENT_MANAGER', value: 'Reusable Content Manager' },
    FORM_USER: { key: 'FORM_USER', value: 'Form User' },
    HYBRID_ROLE: { key: 'HYBRID_ROLE', value: 'Hybrid' },
  };

  export const MANAGE_SHORT_MESSAGE_ACCOUNT = {
    MANAGE_SHORT_MESSAGE_TTILE: {
      key: 'MANAGE_SHORT_MESSAGE_TTILE',
      value: 'Manage Short Message Account Configuration Details',
    },
    MANAGE_SHORT_MESSAGE_DESCRIPTION: {
      key: 'MANAGE_SHORT_MESSAGE_DESCRIPTION',
      value: 'Manage Short Message Account Configuration Details here',
    },
    WHATSAPP_LABEL: {
      key: 'WHATSAPP_LABEL',
      value: 'whatsapp',
    },
    WHATSAPP_DESCRIPTION: {
      key: 'WHATSAPP_DESCRIPTION',
      value: 'Deliver whatsapp messages through DOC studio to your customers using this number',
    },
    SMS_LABEL: {
      key: 'SMS_LABEL',
      value: 'sms',
    },
    SMS_DESCRIPTION: {
      key: 'SMS_DESCRIPTION',
      value: 'Deliver text messages through DOC studio to your customers using this number',
    },
    CALL_LABEL: {
      key: 'CALL_LABEL',
      value: 'call',
    },
    CALL_DESCRIPTION: {
      key: 'CALL_DESCRIPTION',
      value: 'Deliver audio messages through DOC studio to your customers using this number',
    },
    INVALID_MOBILE_NUMBER_ERROR_MESSAGE: {
      key: 'INVALID_MOBILE_NUMBER_ERROR_MESSAGE',
      value: 'Invalid Number',
    },
    EMPTY_MOBILE_NUMBER_INPUT_ERROR_MESSAGE: {
      key: 'EMPTY_MOBILE_NUMBER_INPUT_ERROR_MESSAGE',
      value: 'Enter Valid Number',
    },
    CONFIG_TWILIO_ACCOUNT_WARNING_MESSAGE: {
      key: 'CONFIG_TWILIO_ACCOUNT_WARNING_MESSAGE',
      value: 'Please Config Twilio Account',
    },
    CANCEL_UPDATING_NUMBER_TOOLTIP: {
      key: 'CANCEL_UPDATING_NUMBER_TOOLTIP',
      value: 'Cancel',
    },
    UPDATE_MOBILE_NUMBER_TOOLTIP: {
      key: 'UPDATE_MOBILE_NUMBER_TOOLTIP',
      value: 'Update Number',
    },
    EDIT_MOBILE_NUMBER_TOOLTIP: {
      key: 'EDIT_MOBILE_NUMBER_TOOLTIP',
      value: 'Edit number',
    },
    INVALID_MOBILE_NUMBER_INPUT_ERROR_MESSAGE: {
      key: 'INVALID_MOBILE_NUMBER_INPUT_ERROR_MESSAGE',
      value: 'Enter Valid Number',
    },
    EMPTY_AUTH_KEY_ERROR_MESSAGE: {
      key: 'INVALID_MOBILE_NUMBER_ERROR_MESSAGE',
      value: 'Please Enter the valid authorization key',
    },
    EMPTY_ACCOUNT_SID: {
      key: 'INVALID_MOBILE_NUMBER_ERROR_MESSAGE',
      value: 'Please Enter the valid account SID',
    },
    EDIT_CONFIG_BUTTON: {
      key: 'EDIT_CONFIG_BUTTON',
      value: 'Edit Config',
    },
    TWILIO_CONFIG_UPDATED_SUCCESSFULLY: {
      key: 'TWILIO_CONFIG_UPDATED_SUCCESSFULLY',
      value: 'Twilio Config Updated Successfully',
    },
  };
  
  export const SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL = {
    EMPTY_AUTH_KEY_ERROR_MESSAGE: {
      key: 'EMPTY_AUTH_KEY_ERROR_MESSAGE',
      value: 'Please Enter the valid authorization key',
    },
    EMPTY_ACCOUNT_SID_ERROR_MESSAGE: {
      key: 'EMPTY_ACCOUNT_SID_ERROR_MESSAGE',
      value: 'Please Enter the valid account SID',
    },
    SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL_TITLE: {
      key: 'SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL_TITLE',
      value: 'Twilio Account Configuration',
    },
    ADD_SHORT_MESSAGE_ACCOUNT_BUTTON: {
      key: 'ADD_SHORT_MESSAGE_ACCOUNT_BUTTON',
      value: 'Add',
    },
    ADDING_SHORT_MESSAGE_ACCOUNT_TEXT: {
      key: 'ADDING_SHORT_MESSAGE_ACCOUNT_TEXT',
      value: 'Adding',
    },
    UPDATE_SHORT_MESSAGE_ACCOUNT_BUTTON: {
      key: 'UPDATE_SHORT_MESSAGE_ACCOUNT_BUTTON',
      value: 'update',
    },
    UPDATING_SHORT_MESSAGE_ACCOUNT_TEXT: {
      key: 'UPDATING_SHORT_MESSAGE_ACCOUNT_TEXT',
      value: 'updating',
    },    
    AUTH_KEY_LABEL: {
      key: 'AUTH_KEY_LABEL',
      value: 'Authorization key(Auth_Token)',
    },  
    AUTH_KEY_PLACEHOLDER: {
      key: 'AUTH_KEY_PLACEHOLDER',
      value: 'Authorization key',
    },  
    ACC_SID_LABEL: {
      key: 'ACC_SID_LABEL',
      value: 'Account SID(acc_SID)',
    },  
    ACC_SID_PLACEHOLDER: {
      key: 'ACC_SID_PLACEHOLDER',
      value: 'Account SID',
    },
    TWILIO_CONFIG_ADD_SUCCESS: {
      key: 'TWILIO_CONFIG_ADD_SUCCESS',
      value: 'Twilio config added successfully'
    },
    TWILIO_CONFIG_ADD_FAILURE: {
      key: 'TWILIO_CONFIG_ADD_FAILURE',
      value: 'Failed to add Twilio config'
    },
    TWILIO_CONFIG_UPDATE_SUCCESS: {
      key: 'TWILIO_CONFIG_UPDATE_SUCCESS',
      value: 'Twilio config updated successfully'
    },
    TWILIO_CONFIG_UPDATE_FAILURE: {
      key: 'TWILIO_CONFIG_UPDATE_FAILURE',
      value: 'Failed to update Twilio config'
    }
  };
  
  export const MANAGE_TEXT_TO_SPEECH_CONFIGURATION = {
    MANAGE_TEXT_TO_SPEECH_CONFIGURATION_TITLE: {
      key: 'MANAGE_TEXT_TO_SPEECH_CONFIGURATION_TITLE',
      value: "Manage Text To Speech Configuration Details",
    },    
    INVALID_INPUT_WARNING_MESSAGE: {
      key: 'INVALID_INPUT_WARNING_MESSAGE',
      value: 'Please enter valid {{name}} input',
    },
    UNABLE_TO_ADD_OR_UPDATE_ERROR_MESSAGE: {
      key: 'UNABLE_TO_ADD_OR_UPDATE_ERROR_MESSAGE',
      value: 'Unable to add or update the configuration',
    },
    ADDED_CONFIGURATION_SUCCESS_MESSAGE: {
      key: 'ADDED_CONFIGURATION_SUCCESS_MESSAGE',
      value: 'Added Successfully!',
    },
    ADD_CONFIGURATION_BUTTON: {
      key: 'ADD_CONFIGURATION_BUTTON',
      value: 'Add',
    },
    EDIT_CONFIGURATION_BUTTON: {
      key: 'EDIT_CONFIGURATION_BUTTON',
      value: 'Edit',
    },
    UPDATE_CONFIGURATION_BUTTON: {
      key: 'UPDATE_CONFIGURATION_BUTTON',
      value: 'Update',
    },
    CONFIG_TYPE_LABEL: { key: 'CONFIG_TYPE_LABEL', name: 'Type' },
    CONFIG_PROJECT_ID_LABEL: { key: 'CONFIG_PROJECT_ID_LABEL', name: 'Project Id' },
    CONFIG_PRIVATE_KEY_ID_LABEL: { key: 'CONFIG_PRIVATE_KEY_ID_LABEL', name: 'Private key Id' },
    CONFIG_PRIVATE_KEY_LABEL: { key: 'CONFIG_PRIVATE_KEY_LABEL', name: 'Private Key' },
    CONFIG_CLIENT_EMAIL_LABEL: { key: 'CONFIG_CLIENT_EMAIL_LABEL', name: 'Client Email' },
    CONFIG_CLIENT_ID_LABEL: { key: 'CONFIG_CLIENT_ID_LABEL', name: 'Client Id' },
    CONFIG_AUTH_URI_LABEL: { key: 'CONFIG_AUTH_URI_LABEL', name: 'Auth URI' },
    CONFIG_TOKEN_URI_LABEL: { key: 'CONFIG_TOKEN_URI_LABEL', name: 'Token URI' },
    CONFIG_AUTH_PROVIDER_CERT_URL_LABEL: {
      key: 'CONFIG_AUTH_PROVIDER_CERT_URL_LABEL',
      name: 'Auth_Provider x509_cert_url',
    },
    CONFIG_CLIENT_CERT_URL_LABEL: {
      key: 'CONFIG_CLIENT_CERT_URL_LABEL',
      name: 'Client_x509_cert_url',
    },
  };
  
export const ALERT_AND_NOTIFICATIONS = {
  ALERTS_AND_NOTIFICATIONS_HEADING: {
    key: 'ALERTS_AND_NOTIFICATIONS_HEADING', value: 'Alerts & Notifications'
  },
  ALERTS_AND_NOTIFICATIONS_DESCRIPTION: {
    key: 'ALERTS_AND_NOTIFICATIONS_DESCRIPTION',
    value: 'Send notification emails to users when a specific threshold is exceeded.'
  },
  ALERT_RECIPIENTS_LABEL: {
    key: 'ALERT_RECIPIENTS_LABEL', value: 'Threshold Alert Recipients:'
  },
  DELETE_CONFIRMATION_TITLE: {
    key: 'DELETE_CONFIRMATION_TITLE',
    value: 'Do you want to proceed with deleting this email ID?'
  },
  DELETE_POPOVER_NO_TEXT: {
    key: 'DELETE_POPOVER_NO_TEXT', value: 'No'
  },
  DELETE_POPOVER_YES_TEXT: {
    key: 'DELETE_POPOVER_YES_TEXT', value: 'Yes'
  },
  ADD_EMAIL_ADDRESS_LABEL: {
    key: 'ADD_EMAIL_ADDRESS_LABEL', value: 'Add Email Address:'
  },
  EMAIL_ADDRESS_PLACEHOLDER: {
    key: 'EMAIL_ADDRESS_PLACEHOLDER', value: 'Please enter email address'
  },
  THRESHOLD_LABEL: {
    key: 'THRESHOLD_LABEL', value: 'Threshold:'
  },
  THRESHOLD_INFO: {
    key: 'THRESHOLD_INFO',
    value: 'Set the threshold percentage: Alerts will be sent to the specified email IDs if this percentage is exceeded.'
  },
  SAVING_TEXT: {
    key: 'SAVING_TEXT', value: 'Saving...'
  },
  GET_THRESHOLD_ERROR_MESSAGE: {
    key: 'GET_THRESHOLD_ERROR_MESSAGE',
    value: 'An error occurred while retrieving threshold details.'
  },
  INVALID_EMAIL_ADDRESS_ERROR_MESSAGE: {
    key: 'INVALID_EMAIL_ADDRESS_ERROR_MESSAGE',
    value: 'Please enter a valid email address.'
  },
  EMAIL_ID_EXISTS_ERROR_MESSAGE: {
    key: 'EMAIL_ID_EXISTS_ERROR_MESSAGE',
    value: 'The entered email address already exists.',
  },
  ADD_EMAIL_ADDRESS_ERROR_MESSAGE: {
    key: 'ADD_EMAIL_ADDRESS_ERROR_MESSAGE',
    value: 'An error occurred while adding the email address. Please try again later.'
  },
  DELETE_EMAIL_ADDRESS_ERROR_MESSAGE: {
    key: 'DELETE_EMAIL_ADDRESS_ERROR_MESSAGE',
    value: 'An error occurred while removing the email address. Please try again later.'
  },
  INVALID_THRESHOLD_ERROR_MESSAGE: {
    key: 'INVALID_THRESHOLD_ERROR_MESSAGE',
    value: 'The threshold value must be a number between 0 and 100.'
  },
  UPDATE_THRESHOLD_ERROR_MESSAGE: {
    key: 'UPDATE_THRESHOLD_ERROR_MESSAGE',
    value: 'An error occurred while updating the threshold. Please try again later.'
  }
}

export const EXTERNAL_SERVICES = {
  EXTERNAL_SERVICES_HEADING: { key: 'EXTERNAL_SERVICES_HEADING', value: 'External Email/SMS Configuration' },
  EXTERNAL_SERVICES_DESC: { key: 'EXTERNAL_SERVICES_DESC', value: 'Set up external email and SMS services with your preferred provider by entering the required integration details.' },
  PRINT_LABEL: { key: 'PRINT_LABEL', value: 'Print' },
  EMAIL_LABEL: { key: 'EMAIL_LABEL', value: 'Email' },  
  SMS_LABEL: { key: 'SMS_LABEL', value: 'SMS' },
  CONFIGURED_LABEL: { key: 'CONFIGURED_LABEL', value: 'Configured' },
  UPDATE_BUTTON: { key: 'UPDATE_BUTTON', value: 'Update' },
  CONFIGURE_BUTTON: { key: 'CONFIGURE_BUTTON', value: 'Configure' },
  API_URL_FORM_LABEL: { key: 'API_URL_FORM_LABEL', value: 'API URL' },
  API_URL_HELP_TEXT: { key: 'API_URL_HELP_TEXT', value: 'This is the endpoint URL for configuring the external service.' },
  PROTECTED_CHECKBOX_FORM_LABEL: { key: 'PROTECTED_CHECKBOX_FORM_LABEL', value: 'Protected' },
  BASIC_AUTHENTICATION_RADIO_OPTION: { key: 'BASIC_AUTHENTICATION_RADIO_OPTION', value: 'Basic Authentication' },
  TOKEN_RADIO_OPTION: { key: 'TOKEN_RADIO_OPTION', value: 'Token' },
  CONFIGURATION_UPDATED_SUCCESS_MESSAGE: { key: 'CONFIGURATION_UPDATED_SUCCESS_MESSAGE', value: 'The external service configuration has been updated successfully!' },
  CONFIGURATION_ADDED_SUCCESS_MESSAGE: { key: 'CONFIGURATION_ADDED_SUCCESS_MESSAGE', value: 'The external service has been configured successfully.' },
  EMPTY_INPUTS_ERROR_MESSAGE: { key: 'EMPTY_INPUTS_ERROR_MESSAGE', value: 'Please fill in all authentication details.' },
  EMPTY_INPUT_ERROR_MESSAGE: { key: 'EMPTY_INPUT_ERROR_MESSAGE', value: 'Please fill in this required field.' },
  BEGINNING_SPACE_NOT_ALLOWED_ERROR_MESSAGE: { key: 'BEGINNING_SPACE_NOT_ALLOWED_ERROR_MESSAGE', value: 'Input must begin with a non-space character.' },
}

export const MANAGE_HYBRID_MAIL_CONFIG = {
    MANAGE_HYBRID_MAIL_CONFIG_TITLE: { key: 'MANAGE_HYBRID_MAIL_CONFIG_TITLE', value: 'Manage Hybrid Mail Configuration' },
    MANAGE_HYBRID_MAIL_CONFIG_DESCRIPTION: { key: 'MANAGE_HYBRID_MAIL_CONFIG_DESCRIPTION', value: 'Manage configuration used for Hybrid Mail' },
    ENABLE_HYBRID_MENU_LABEL: { key: 'ENABLE_HYBRID_MENU_LABEL', value: 'Enable Hybrid Mail Menu' },
    ENABLE_HYBRID_MENU_DESCRIPTION: { key: 'ENABLE_HYBRID_MENU_DESCRIPTION', value: 'Hybrid Mail to import documents and send letter for print' },
    HYBRID_MAIL_EDITABLE_LABEL: { key: 'HYBRID_MAIL_EDITABLE_LABEL', value: 'Hybrid Mail Editable'},
    HYBRID_MAIL_EDITABLE_DESCRIPTION: { key: 'HYBRID_MAIL_EDITABLE_DESCRIPTION', value: 'Import the document and edit the content before sending the letter'},
    HYBRID_MAIL_MENU_DISABLE_CONFIRM_MESSAGE: { key: 'HYBRID_MAIL_MENU_DISABLE_CONFIRM_MESSAGE', value: 'Are you sure you want to disable Hybrid Mail menu?' },
    HYBRID_MAIL_MENU_ENABLE_SUCCESS_MESSAGE: { key: 'HYBRID_MAIL_MENU_ENABLE_SUCCESS_MESSAGE', value: 'Hybrid Mail menu enabled! You can now import documents to send letter in Hybrid Mail.' },
    HYBRID_MAIL_MENU_DISABLED_MESSAGE: { key: 'HYBRID_MAIL_MENU_DISABLED_MESSAGE', value: 'Hybrid Mail Menu has been disabled.' },
    EDITABLE_DISABLE_CONFIRM_MESSAGE: { key: 'EDITABLE_DISABLE_CONFIRM_MESSAGE', value: 'Are you sure you want to disable editing for Hybrid Mail?' },
    EDITABLE_ENABLE_SUCCESS_MESSAGE: { key: 'EDITABLE_ENABLE_SUCCESS_MESSAGE', value: 'Editable enabled! Now you can edit the letter in Hybrid Mail after import.' },
    EDITABLE_DISABLED_MESSAGE: { key: 'EDITABLE_DISABLED_MESSAGE', value: 'Editable has been disabled for Hybrid Mail.' },
    ENABLE_HYBRID_MAIL_MENU_UPDATE_FAILED: { key: 'ENABLE_HYBRID_MAIL_MENU_UPDATE_FAILED', value: 'An error occured while trying to enable Hyrbid Mail Menu' },
    PROCEED_BUTTON_LABEL: { key: 'PROCEED_BUTTON_LABEL', value: 'Proceed' },
    EDITABLE_UPDATE_FAILED: { key: 'EDITABLE_UPDATE_FAILED', value: 'An error occured while trying to toggle Hybrid Mail editable' },
}